import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import WhiteArrow from "../assets/images/button-arrow.png";
import Footer from "../Components/Footer";
import InfoBanner from "../Components/InfoBanner";
import DownloadModal from "../Components/modal/DownloadModal";
import NavBar from "../Components/NavBar";
import IntroTitle from "../Components/shared/IntroTitle";

const Pricing = () => {
  const [downloadLink, setDownloadLink] = useState("");
  const [openDownloadModal, setOpenDownloadModal] = useState(false);

  useEffect(() => {
    if (window.navigator.userAgent.match(/Android/i)) {
      // Device is an Android
      setDownloadLink(
        "https://play.google.com/store/apps/details?id=com.A1Tutor.a1_app"
      );
    } else if (window.navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      // Device is an iPhone, iPad, or iPod
      setDownloadLink("https://apps.apple.com/ng/app/a1tutor/id1595970443");
    } else if (window.navigator.userAgent.match(/IEMobile/i)) {
      // Device is a Windows Phone
      setDownloadLink(
        "https://play.google.com/store/apps/details?id=com.A1Tutor.a1_app"
      );
    } else {
      // Device is a desktop or laptop
      setDownloadLink(
        "https://play.google.com/store/apps/details?id=com.A1Tutor.a1_app"
      );
    }
  }, []);

  return (
    <>
      <main className="container-fluid px-0">
        <InfoBanner />

        <NavBar setOpenDownloadModal={setOpenDownloadModal} />
        <header className="container-fluid pricing-header">
          <div className="container">
            <div className="row">
              <div className="col-xl-8 col-lg-10 mx-auto pricing-header-content">
                <div className="col-lg-11 mx-auto">
                  <IntroTitle>
                    Don’t worry! The A1Tutor app is a FREE learning App
                  </IntroTitle>
                </div>

                <div>
                  <a href={downloadLink} style={{ textDecoration: "none" }}>
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      className="white-btn justify-content-center d-flex align-items-center mx-auto"
                      style={{ gap: "5px" }}
                    >
                      <span>Download App</span>
                      <span>
                        <img
                          src={WhiteArrow}
                          alt=""
                          style={{ width: "14px" }}
                        />
                      </span>
                    </motion.button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </header>
        <Footer />
      </main>
      {openDownloadModal && (
        <DownloadModal setOpenDownloadModal={setOpenDownloadModal} />
      )}
    </>
  );
};

export default Pricing;
